import { useEffect } from "react"
import { DigitalWaiver } from "../components/additionalInfo/DigitalWaiver/DigitalWaiver"
import { Questions } from "../components/additionalInfo/Questions/Questions"
// import { CancellationPolicy } from "../components/additionalInfo/CancellationPolicy/CancellationPolicy"
import { useWizardContext } from "../WizardContext"
import { buildAdditionalInfoPayload } from "../mappers/toApiPayload"

export const AdditionalInfoStep = () => {
  const { form, stepSaveHandlersRef, trip } = useWizardContext()

  useEffect(() => {
    stepSaveHandlersRef.current["additional_info"] = () => {
      const selectedWaiverIds = form.getFieldValue("digital_waiver") || []
      const questionTemplateId = form.getFieldValue("question_template") ?? null
      return buildAdditionalInfoPayload({
        selectedWaiverIds,
        // join records ({ id, digital_waiver_id }) — needed to emit _destroy for removals
        existingWaiverJoins: trip?.digital_waiver_experiences || [],
        questionTemplateId
      })
    }
    return () => {
      delete stepSaveHandlersRef.current["additional_info"]
    }
  }, [form, stepSaveHandlersRef, trip])

  return (
    <div>
      <DigitalWaiver />
      <Questions />
      {/* <CancellationPolicy /> */}
    </div>
  )
}
